<mat-toolbar *ngIf="content" class="default-padding">
  <mat-toolbar-row>
    <span class="f-24"> {{ content.title || 'Quest Detect' }} </span>
    <span class="spacer"></span>
    <mat-icon class="profile-picture" *ngIf="!content.author.logoUrl" aria-hidden="false" aria-label="Image">perm_identity</mat-icon>
    <img class="profile-picture" *ngIf="content.author.logoUrl" [src]="content.author.logoUrl" alt="logo">
    <span class="font-light f-16"> {{ content.author.name }} </span>
  </mat-toolbar-row>
</mat-toolbar>